"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_mail__new(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "660e5cce-ddb6-4a0a-96f0-adac0b6e98c5",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160,152H32a16,16,0,0,1-16-16V48a8,8,0,0,1,8-8H168a8,8,0,0,1,8,8v88A16,16,0,0,1,160,152Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b1f930e7-53c2-4ac2-a4fe-0f81129cc063",
    x1: 56,
    y1: 16,
    x2: 179.31,
    y2: 139.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "mail-new-hi"), /*#__PURE__*/React.createElement("g", {
    id: "1858b8aa-ca08-418a-bb62-adf3f31f7772",
    "data-name": "mail-new-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "80fb6a32-535a-4cae-af6c-cffc79925300",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "82646521-6db1-4708-bda2-c8addad0d0ae",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d0eda4ee-6f83-4e78-9300-52574ffb75be",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a5de9b18-0f0e-4658-aa0c-20f9272d9186",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "64a75a9e-a749-4f47-afb9-d8473087ddfd",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e04b62e6-df09-4fbe-aa30-5fafc739a620",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bbb05bc5-f5d2-41dd-af4c-1010346f25c2",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d579a602-27d2-455d-9f25-9e96ec6b33ee",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "22668916-ac92-44e8-a449-097dc0b2097e",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3144241f-a777-4ed6-9681-2ef23428b436",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c6807cbc-7674-4c84-a55d-c5c61e54699d",
    "data-name": "Document_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bde8a687-1aef-4521-95f4-3a2478186901",
    "data-name": "Edit_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "182cdf8a-4fb5-492b-aa16-bb426d2852b0",
    "data-name": "Enterprise_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bb97835d-044f-46c4-983c-77c4df0c69c2",
    "data-name": "Call_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "681e4ec2-9901-49bc-971c-66f9c1935fcd",
    "data-name": "Location_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1c215134-6f25-4d6b-9ff4-645d9c168f13",
    "data-name": "Mail_new_ic_hi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160,152H32a16,16,0,0,1-16-16V48a8,8,0,0,1,8-8H168a8,8,0,0,1,8,8v88A16,16,0,0,1,160,152Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#660e5cce-ddb6-4a0a-96f0-adac0b6e98c5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,56l96,96h48a16,16,0,0,0,16-16V56Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#b1f930e7-53c2-4ac2-a4fe-0f81129cc063)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M168,40H24a8,8,0,0,0-8,8v8L84,98s5.83,4,12,4,12-4,12-4l68-42V48A8,8,0,0,0,168,40Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,100c-6.17,0-12-4-12-4L16,54v2L84,98s5.83,4,12,4,12-4,12-4l68-42V54L108,96S102.17,100,96,100Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,150H32a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16H160a16,16,0,0,0,16-16v-2A16,16,0,0,1,160,150Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    id: "64d3976f-ad27-4f64-a974-ce3c95a9374a",
    "data-name": "Bounding Box",
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,72a12,12,0,1,0,12,12A12,12,0,0,0,96,72Zm5.87,15.22a6.29,6.29,0,0,1-1.72,2.08,6.45,6.45,0,0,1-5.79,1.13,6.85,6.85,0,0,1-3.83-2.87,7.32,7.32,0,0,1-.87-1.93l0-.16a8,8,0,0,1-.22-1.19,8.41,8.41,0,0,1,0-1.24v-.13a9.46,9.46,0,0,1,.26-1.73A10.41,10.41,0,0,1,93,75.82a11.24,11.24,0,0,1,3.29-1.93c.33-.13.66-.24,1-.33l.61-.17a12.16,12.16,0,0,1,1.52-.27,6.11,6.11,0,0,1,1.51,0l.24.06A5,5,0,0,0,97.25,78c0,.05,0,.11,0,.16a7.9,7.9,0,0,1,2.54,1,5.72,5.72,0,0,1,1.66,1.53l.1.14a5.68,5.68,0,0,1,.72,1.54,6.88,6.88,0,0,1,.28,1.74c0,.08,0,.16,0,.23A6.43,6.43,0,0,1,101.87,87.22Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  })))))))))))))))))));
}

var _default = ic_mail__new;
exports.default = _default;